module.exports = __webpack_public_path__ + "static/media/default-poster.7dbfb0fb.png";